import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { getFragmentData } from '@e-socna/data-layer';

import { SplashScreen } from '../../components/SplashScreen';
import { PATH_MISSION_REPORTS_INIT } from '../../app/constants/paths.constant';
import { Loading } from '../../components/Loading';
import { EssayWriting } from '../../components/Illustrations/EssayWriting';
import { FilterableCards } from '../../components/FilterableCards';
import { useBuildPath } from '../../hooks/useBuildPath.hook';
import { useMissionReadyContext } from '../../contexts/MissionContext/hooks/useMissionReadyContext.hook';
import { useMissionAccess } from '../../components/Access/hooks/useMissionAccess.hook';
import { useMissionSpaceWording } from '../../hooks/useMissionSpaceWording.hook';

import { MissionReportPage_ReportInfo_Fragment } from '../MissionReport/fragments/report-info.fragment';

import { useFindAllMissionReportsQuery } from './hooks/useFindAllMissionReportsQuery.hook';
import { ReportCard } from './ReportCard';
import { CreateReportCard } from './CreateReportCard';
import { REPORT_MATCH_SORTER_KEYS } from './constants/report-match-sorter-keys.constant';

export const ReportsWithinAMission = () => {
  const navigate = useNavigate();

  const { folderId, mission, missionId } = useMissionReadyContext();
  const missionWording = useMissionSpaceWording();
  const { initReport: creationGate } = useMissionAccess(missionId, mission);

  const path = useBuildPath(PATH_MISSION_REPORTS_INIT, { folderId, missionId });

  const goToCreationPage = useCallback(
    () => void navigate(path),
    [navigate, path],
  );

  const { data: reportsData, isLoading: areReportsLoading } =
    useFindAllMissionReportsQuery(missionId);

  const reports = reportsData?.findSomeReports;

  if (!mission.reportInfos.length) {
    return (
      <SplashScreen
        action={{
          label: 'Initialiser un Rapport',
          onClick: goToCreationPage,
          gate: creationGate,
        }}
        illustration={<EssayWriting />}
        message={`Vous n'avez pas de rapport ${missionWording.ofName} pour le moment. Commencez le travail !`}
      />
    );
  }

  const missionReportInfos = getFragmentData(
    MissionReportPage_ReportInfo_Fragment,
    mission.reportInfos,
  );

  const items = missionReportInfos.map((missionReportInfo) => ({
    _id: missionReportInfo._id,
    missionReportInfo,
    report: reports?.find(
      (report) => report._id === missionReportInfo.reportId,
    ),
  }));

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!areReportsLoading && <Loading />}
      <FilterableCards
        Card={ReportCard}
        createNewCard={
          <CreateReportCard
            gate={creationGate}
            onStartCreate={goToCreationPage}
          />
        }
        id="mission-report-card-list"
        items={items}
        keys={REPORT_MATCH_SORTER_KEYS}
        showSearchBar={false}
      />
    </>
  );
};
